import { useState, forwardRef } from "react";
import { cn } from "@/lib/utils";

interface FloatingInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

const FloatingInput = forwardRef<HTMLInputElement, FloatingInputProps>(
  ({ label, className, value, onFocus, onBlur, ...props }, ref) => {
    const [focused, setFocused] = useState(false);
    const hasValue = value !== undefined && value !== "";
    const isActive = focused || hasValue;

    return (
      <div className="relative">
        <input
          ref={ref}
          value={value}
          onFocus={(e) => {
            setFocused(true);
            onFocus?.(e);
          }}
          onBlur={(e) => {
            setFocused(false);
            onBlur?.(e);
          }}
          className={cn(
            "peer w-full h-12 px-4 pt-5 pb-1 text-sm font-body rounded-lg border bg-background/60 backdrop-blur-sm transition-all duration-300",
            "border-border/60 focus:border-primary focus:ring-2 focus:ring-primary/20 focus:outline-none",
            "placeholder-transparent",
            className
          )}
          placeholder={label}
          {...props}
        />
        <label
          className={cn(
            "absolute left-4 transition-all duration-300 pointer-events-none font-body",
            isActive
              ? "top-1.5 text-[10px] font-semibold text-primary"
              : "top-3.5 text-sm text-muted-foreground"
          )}
        >
          {label}
        </label>
      </div>
    );
  }
);

FloatingInput.displayName = "FloatingInput";

export default FloatingInput;
